<div class="modal__header">
		<div class="modal__header-actions header-actions--mobile">
				<button [attr.aria-label]="'dates.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
						<app-svg svg="icons.svg#general--arrow--left-no_margin" aria-hidden="true" [alt]="'Arrow left icon'"></app-svg>
					</button>
			</div>
		<div class="title_wrapper">
			<h2 class="title" id="modal__title">{{ 'dates.text.selectMonth' | ibeadmin | async}}</h2>
			<span class="sub-title">{{ 'dates.text.months' | ibeadmin | async}}</span>
		</div>
		<div class="modal__header-actions header-actions">
			<button [attr.aria-label]="'dates.aria.closeDialog' | ibeadmin | async" (click)="closeModal()">
				<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
			</button>
		</div>
	</div>

	<div class="modal__body select-months-body sl--scrollable">
		<ul class="months-wrapper">
				<li class="item__month" *ngFor="let month of months; let index = index">
						<button  (click)="INDRA_handleSelectMonthClick(month)" [attr.aria-label]="('dates.aria.select' | ibeadmin | async) + ' ' + month.label + ' ' + ('dates.aria.from' | ibeadmin | async) + ' ' + month.from + currency">
							<span class="item__month-label">{{ INDRA_getMonthYear(month.label) }}</span>
							<span class="item__month-from" *ngIf="INDRA_monthHasMinPrice(month.minCost.currency)">{{ INDRA_printMinPrice(month.minCost.currency) }}</span>
						</button>
				</li>
			</ul>
	</div>
